<style lang="less" scoped>
</style>
<template>
  <v-autocomplete
    v-model="item_value"
    :items="items"
    :item-value="itemValue"
    :rules="rules"
    :loading="loading"
    :search-input.sync="search"
    :label="label"
    :placeholder="calc_placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :no-data-text="noDataText"
    @click:clear="clear"
    @focus="searchItem(search)"
  />
</template>
<script>
  export default {
    props: {
      value: {
        type: [Number, String],
      },
      // 额外的查询数据，search_api 会 merge
      extraData: {
        type: Object,
        default() {
          return {};
        }
      },
      rules: {
        type: Array,
        default() {
          return [];
        }
      },
      label: {
        type: String
      },
      placeholder: {
        type: [String, Number],
        default: '搜索'
      },
      // v-model 值所对应的 key
      itemValue: {
        type: [String, Function],
        default() {
          return 'id'
        }
      },
      // 选项中展示的key
      itemText: {
        type: [String, Function],
        default() {
          return 'name'
        }
      },
      // 选中后展示的key, 可空，默认使用 itemText
      itemSelected: {
        type: String
      },
      itemDefault: {
        type: Object,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      noDataText: {
        type: String,
        default: '没有数据，请搜索'
      },
      // GET 搜索api，返回数据应包含数组
      search_api: {
        type: String,
        required: true
      },
      // GET 获取数据api，返回数据的data中应只包含一个key，对应的value为json
      find_api: {
        type: String,
        required: true
      },
      findKey: {
        type: String,
        default: () => 'id'
      },
      handleFind: {
        type: Function,
      }
    },
    data() {
      const value_key = this.itemValueKey(this.itemDefault);
      return {
        search: '',
        default_value_key: value_key,
        item_value: this.itemDefault[value_key],
        items_hash: {},
        selected_item: {},
        search_result: [],
        loading: false
      }
    },
    computed: {
      items() {
        const default_results = [];
        // 将当前选择始终加入选项中
        if (this.hasSelectedItem()) {
          default_results.push(this.selected_item);
        }
        const items = [];
        const uniq_hash = {};
        this.search_result.concat(default_results).forEach((item) => {
          const value_key = this.itemValueKey(item);
          const value = item[value_key];
          const text_value = this.itemTextValue(item);
          if (!uniq_hash[value]) {
            uniq_hash[value] = true;
            items.push({
              [value_key]: value,
              text: text_value
            })
          }
        })
        return items;
      },
      calc_placeholder() {
        if (this.hasSelectedItem()) {
          return this.itemTextValue(this.selected_item)
        } else {
          return this.placeholder || '...';
        }
      }
    },
    watch: {
      value(val) {
        this.item_value = val;
        if (!val) {
          this.resetItem();
        } else {
          this.initItem();
        }
      },
      item_value(val) {
        this.$emit('input', val);
        this.search = '';
        const item = this.items_hash[val];
        if (item) {
          this.$emit('change', item);
          this.selected_item = item;
        }
      },
      search(val) {
        if (val && val === this.itemTextValue(this.selected_item)) {
          return;
        }
        this.searchItem(val);
      },
      extraData: {
        handler(newVal, oldVal) {
          // 当extraData发生变化时，重新执行搜索
          if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            this.searchItem(this.search);
          }
        },
        deep: true
      }
    },
    created() {
      this.item_value = this.value;
      this.checkConfig();
      this.initItem();
    },
    mounted() {
      //
    },
    methods: {
      // 检查配置是否满足要求
      checkConfig() {
        const default_item_keys = Object.keys(this.itemDefault);
        if (!default_item_keys.includes(this.default_value_key)) {
          throw '配置有误，default-item 中不包含对应的 item-value';
        }
      },
      itemValueKey(item) {
        if (typeof this.itemValue === 'string') {
          return this.itemValue;
        } else if (typeof this.itemValue === 'function') {
          return this.itemValue(item);
        }
      },
      itemTextValue(item) {
        const value_key = this.itemValueKey(item);
        const definedItemSelected = this.itemSelected && item[value_key] === this.value;
        if (definedItemSelected) return item[this.itemSelected];
        if (typeof this.itemText === 'string') {
          return item[this.itemText];
        } else if (typeof this.itemText === 'function') {
          return this.itemText(item);
        }
      },
      resetItem() {
        this.selected_item = {};
      },
      clear() {
        this.selected_item = {};
        const default_value = this.itemDefault[this.default_value_key];
        this.$emit('input', default_value);
        this.$emit('change', this.$util.clone(this.itemDefault));
      },
      hasSelectedItem() {
        const value_key = this.itemValueKey(this.selected_item);
        const value = this.selected_item[value_key];
        return !!value && this.value === value;
      },
      initItem(retry_count = 0) {
        if (this.hasSelectedItem()) return;
        if (!this.value) return;
        if (this.loading) return;
        if (!this.find_api) return;
        this.loading = true;
        this.$util.ajax.get(this.find_api, {
          params: {
            [this.findKey]: this.value
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            if (this.handleFind) {
              this.search_result = this.search_result.concat(this.handleFind(res.data))
            } else {  
              this.handleTakeResult(res.data);
            }
           
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
          // 失败重试
          if (!this.hasSelectedItem() && retry_count < 3) {
            this.initItem(retry_count + 1);
          }
        });
      },
      handleTakeResult(res_data) {
        if (res_data.constructor === Object) {
          const data_keys = Object.keys(res_data);
          if (data_keys.length === 1) {
            this.selected_item = res_data[data_keys[0]];
          } else {
            this.selected_item = res_data
          }
        
        
          this.search = this.itemTextValue(this.selected_item);
          return;
        }
        console.error('返回的数据应为一个JSON对象: ', res_data);
      },
      searchItem(search) {
        // vuetify bug, 把 search 设为 {"isTrusted":true}
        if (search && search.isTrusted) return;
        if (!search && Object.keys(this.extraData).length === 0) return;
        if (this.loading) return;
        this.loading = true;
        const params = Object.assign({search: search}, this.extraData);
        this.$util.ajax.get(this.search_api, {
          params: params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.handleSearchResult(res.data);
          } else {
            this.$Modal.error({title: '提示', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.loading = false;
          if (this.search !== search) {
            this.searchItem(this.search);
          }
        });
      },
      handleSearchResult(res_data) {
        let found_result = false;
        if (res_data.constructor === Array) {
          this.search_result = res_data;
          found_result = true;
        } else if (res_data.constructor === Object) {
          const data_keys = Object.keys(res_data);
          for (const data_key of data_keys) {
            const value = res_data[data_key]
            if (value.constructor === Array) {
              this.search_result = value;
              found_result = true;
              break;
            }
          }
        }
        if (!found_result) {
          console.error('搜索接口返回的数据不包含数组:', res_data);
        }
        this.genItemHash();
      },
      genItemHash() {
        this.search_result.forEach((item) => {
          const value_key = this.itemValueKey(item);
          const value = item[value_key];
          this.items_hash[value] = item;
          if (value === this.item_value) {
            this.selected_item = item;
          }
        });
      },
    }
  }
</script>
